import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import find from 'lodash/find'

import moment from '../../../../lib/moment.js'
import { ProjectItem } from './project-item'
import { FONTS } from '../../../../constants'
import NotAvailable from '../../../../static/images/timesheet-not-available.svg'

const filterMyTimesheet = (data, myProjects, locations, searchTimesheet) => {
  return data.filter((element) => {
    const approvers = element.approvers
    const approver = find(approvers, { _id: element.approver_id })
    const approverName = approver ?
      `${approver.emp_code.toLowerCase()} - ${approver.first_name.toLowerCase()} ${approver.last_name.toLowerCase()} (${approver.nick_name.toLowerCase()})` : ''
    const search = searchTimesheet.toLowerCase()
    const project = find(myProjects, { _id: element.project_id })
    const projectCode = project ? project.project_code.toLowerCase() : ''
    const projectName = project ? project.name.toLowerCase() : ''
    if (approverName.includes(search)
    || projectCode.includes(search)
    || projectName.includes(search)) return true
    const result = find(get(element, 'tasks', []), (task) => {
      const location = find(locations, { value: task.location_id })
      const locationName = location ? location.label.toLowerCase() : ''
      const taskName = task.task_name.toLowerCase()
      return locationName.includes(search) || taskName.includes(search)
    })
    return result
  })
}

const sumTotalHoursProject = (project) => {
  let sum = 0
  get(project, 'tasks', []).forEach(task => {
    get(task, 'times', []).forEach(time => {
      sum += Number(get(time, 'hours', 0))
    })
  })
  return sum
}

export const DataRow = (props) => {
  const [index, setIndex] = useState(1)
  const { myProjects, locations, searchTimesheet } = props
  let myTimesheet = get(props, 'myTimesheet.timesheet.projects', [])
  myTimesheet = filterMyTimesheet(myTimesheet, myProjects, locations, searchTimesheet)
  const hiring_date = get(props, 'authData.user.hiring_date')
  const last_effective_date = get(props, 'authData.user.last_effective_date')
  const selectedDate = get(props, 'selectedDate')
  const isBeforeHiringDate = moment(selectedDate).isBefore(hiring_date, 'months')
  const isAfterLastEffectiveDate = moment(selectedDate).isAfter(last_effective_date, 'months')

  useEffect(() => {
    let interval
    if (index < myTimesheet.length) {
      interval = setInterval(addItems, 25)
    }
    return () => clearInterval(interval)
  }, [myTimesheet, index])

  const addItems = () => {
    if (index + 1 < myTimesheet.length - 1) {
      setIndex(index + 1)
    } else {
      setIndex(myTimesheet.length)
    }
  }

  if (isBeforeHiringDate || isAfterLastEffectiveDate) {
    return (
      <IconWrapper>
        <Icon src={ NotAvailable } alt='notAvailable' />
        <span style={ { fontFamily: FONTS.GOTHAM_MEDIUM, fontSize: FONTS.TITLE_SIZE } }>
          Timesheet data not available
        </span>
        <span style={ { fontFamily: FONTS.GOTHAM, fontSize: FONTS.SMALL_SIZE } }>
          { `There is no timesheet data for your account in this month.`}
        </span>
      </IconWrapper>
    )
  }
  return (
    <Wrapper>
      { myTimesheet.slice(0, index).map(project => {
        const sumTotalProject = sumTotalHoursProject(project)
        return (
          <ProjectItem
            project={ project }
            myProjects={ myProjects }
            sumTotalProject={ sumTotalProject }
            tasks={ get(project, 'tasks', []) }
            { ...props }
          />
        )
      })
      }
    </Wrapper>
  )
}

DataRow.propTypes = {
  myProjects: PropTypes.array,
  locations: PropTypes.array,
  searchTimesheet: PropTypes.string,
}

DataRow.defaultProps = {
  myProjects: [],
  locations: [],
  searchTimesheet: '',
}

const Wrapper = styled.div`
  background-color: #FFFFFF;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`

const IconWrapper = styled.div`
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 50px 50px 50px;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`

const Icon = styled.img`
  height: 200px;
  width: 200px;
  cursor: pointer;
`




// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/my-timesheet/data-row.js